import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/translation/deleteRows/translation.deleteTypeValues.mutation.gql"
import type {
  TranslationDeleteTypeValuesMutation,
  TranslationDeleteTypeValuesMutationVariables,
} from "@/v2-backoffice-client/translation/deleteRows/__types__/translation.deleteTypeValues.mutation"

type Options = MutationHookOptions<
  TranslationDeleteTypeValuesMutation,
  TranslationDeleteTypeValuesMutationVariables
>

export function useTranslationDeleteTypeValuesMutation(options?: Options) {
  return useMutation<
    TranslationDeleteTypeValuesMutation,
    TranslationDeleteTypeValuesMutationVariables
  >(mutation, {
    // Soft-deleted type values leave the catalog board on refetch
    // (api.Get_Common_TypeValueTranslations filters IsDeleted).
    refetchQueries: ["TranslationCatalogQuery"],
    ...options,
  })
}
